import React from "react";

export default function RenewalSuccess() {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.h1}>Thank you for renewing your membership!</h1>

        <p style={styles.p}>Your membership has been renewed.</p>

        <p style={styles.p}>
          If you have any additional questions, please contact your store directly.
        </p>

        <div style={styles.footer}>Powered by Talvik</div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    fontFamily:
      'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto',
   // background: "#f7f7f7",
    minHeight: "100vh",
    padding: "0 12px",
  },
  container: {
    maxWidth: 600,
    margin: "80px auto",
    background: "#ffffff",
    padding: 32,
    borderRadius: 12,
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
    textAlign: "center",
  },
  h1: {
    color: "#2e7d32",
    marginBottom: 12,
    fontSize: 24,
  },
  p: {
    color: "#444",
    lineHeight: 1.6,
    margin: "10px 0",
    fontSize: 16,
  },
  footer: {
    marginTop: 30,
    fontSize: "0.9em",
    color: "#777",
  },
};
